module.exports = __webpack_public_path__ + "static/media/sense4006.4ca314d1.jpg";